import $ from 'jquery'
import 'waypoints/lib/noframework.waypoints.min'

export const renderLazyLoadGoogleMaps = (
  lazymap = document.getElementById('map'),
) => {
  const waypoint = new Waypoint({
    element: lazymap,
    handler(direction) {
      if ($(lazymap).children().length == 0) {
        renderMap(lazymap, window.drupalSettings.google.map.points.slice(0, 1))
      }
    },
    offset: '90%',
  })
}
